<template lang="pug">
  a.btn-book.btn.btn-secondary.btn-lg.bottom-button.font-bold(
    :href="targetUrl"
  ) {{ text }}
</template>

<script>
import EventBus from '@utils/event-bus'

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    targetBaseUrl: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      minScrollHeight: 600,
      maxScrollHeight: 0,
      hidden: true,
      checkIn: undefined,
      checkOut: undefined
    }
  },

  computed: {
    targetUrl () {
      const url = new URL(this.targetBaseUrl)
      const searchParams = url.searchParams

      if (this.checkIn) searchParams.set("check_in", this.checkIn)
      if (this.checkOut) searchParams.set("check_out", this.checkOut)
      return url.toString()
    }
  },

  created () {
    const event = document.addEventListener('scroll', this.switchScrollHandler)
    this.$once('hook:destroyed', () => {
      event.removeEventListener('scroll', this.switchScrollHandler)
    })
    EventBus.$on('reservation-dates-changed', ({ checkIn, checkOut }) => {
      this.checkIn = checkIn
      this.checkOut = checkOut
    })
  },

  mounted () {
    this.footer = document.querySelector('.main-footer')
    this.maxScrollHeight = document.documentElement.scrollHeight - this.footer.offsetHeight - 400
  },

  methods: {
    switchScrollHandler (event) {
      const scrollPosition = event.srcElement.documentElement.scrollTop
      this.hidden = scrollPosition >= this.minScrollHeight && scrollPosition < this.maxScrollHeight
    }
  }
}
</script>
